import React from "react"
import { Carousel, Spin } from "antd"
import { Waypoint } from "react-waypoint"
import PropTypes from "prop-types"
import EmbeddedExperienceCard from "../../../../Embedded/ExperienceCard/index"
import { getExperienceMainPhoto } from "../../utils/getExperienceMainPhoto"
import { isLastPage } from "helpers/pagination"
import styles from "./index.module.css"

const ExperienceCarousel = ({ experiences, guuid, loading, hasMore, onLoadMore, metadata, scrollableAncestor }) => {
  return (
    <div className={styles.carouselContainer}>
      <Carousel
        dotPosition="bottom"
        dots={experiences?.length > 3 ? { className: styles.dots } : false}
        slidesToShow={3}
        slidesToScroll={1}
        infinite={false}
        arrows={false}
        lazyLoad="ondemand"
        swipeToSlide={true}
        draggable={true}
        centerMode={false}
        className={styles.experienceCarousel}
        autoplay={false}
        autoplaySpeed={2000}
        dotActiveWidth={20}
        responsive={[
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "40px"
            }
          }
        ]}
      >
        {experiences?.map((exp, index) => {
          const mainPhotoUrl = getExperienceMainPhoto(exp)

          return (
            <div key={exp?.uuid || index} className={styles.carouselItem}>
              <EmbeddedExperienceCard
                image={mainPhotoUrl}
                title={exp?.title}
                location={exp?.address}
                time={exp?.available_hours_range}
                people={exp?.max_guests}
                price={exp?.min_price}
                experienceId={exp?.uuid}
                showFavoriteButton={true}
                favorite={exp?.is_favorite}
                mode="guideProfile"
                guuid={guuid}
                tripPrices={exp?.trip_prices}
              />
            </div>
          )
        })}
      </Carousel>

      {!isLastPage(metadata) && hasMore && (
        <Waypoint
          onEnter={onLoadMore}
          scrollableAncestor={scrollableAncestor}
          bottomOffset="-200px"
        />
      )}

      {loading && (
        <div className={styles.loadingContainer}>
          <Spin size="large" />
        </div>
      )}
    </div>
  )
}

ExperienceCarousel.propTypes = {
  experiences: PropTypes.arrayOf(PropTypes.object).isRequired,
  guuid: PropTypes.string,
  loading: PropTypes.bool,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
  metadata: PropTypes.object,
  scrollableAncestor: PropTypes.object
}

ExperienceCarousel.defaultProps = {
  loading: false,
  hasMore: true,
  guuid: null,
  metadata: null,
  scrollableAncestor: null
}

export default ExperienceCarousel
